export enum EmailType {
  LockRequestEmail = 'lock-request',
}
